var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M23.485 9.343 17.828 15l5.657 5.657-2.829 2.828L15 17.828l-5.657 5.657-2.829-2.828L12.171 15 6.514 9.343l2.829-2.828L15 12.172l5.656-5.657z"
  })));
};
export default SvgCancel;